import React, { useEffect } from "react";

const GoogleReviews = () => {
  useEffect(() => {
    // Cria o script Elfsight dinamicamente
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);

    // Remove o script se o componente for desmontado
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="elfsight-app-343f8cc9-5bee-44ad-ace3-4dcbbbc3fdfa"
      data-elfsight-app-lazy
    ></div>
  );
};

export default GoogleReviews;
